import React, { FunctionComponent } from 'react';
import { graphql, Link, useStaticQuery } from 'gatsby';
import { InternalLinkIcon } from '../../Icons';
import { urlFor } from '../../../utils/imageBuilder';
import { formatLink } from '../../../utils/formatLink';
import { PagePath, ParentPage, SanityImage, SanitySlug, SanityTeaser } from '../../../types/common';
import './styles.scss';

type ExtraContentVideosProps = {
  data: {
    title?: string | null;
    description?: string | null;
    cta?: string | null;
    videos: {
      _id: string;
      title: string;
      image: SanityImage;
      teaser?: SanityTeaser | null;
      parentPage: ParentPage | null;
      slug: SanitySlug;
    }[];
  };
}

type QueryData = {
  allSanityVideoLandingPage: {
    nodes: PagePath[];
  };
}

const ExtraContentVideos: FunctionComponent<ExtraContentVideosProps> = ({ data }) => {
  const query = (useStaticQuery<QueryData>(graphql`
    {
      allSanityVideoLandingPage {
        nodes {
          _id
          parentPage {
            slug {
              current
            }
          }
          slug {
            current
          }
        }
      }
    }
  `));

  const videosPage = query.allSanityVideoLandingPage.nodes[0];

  return (
    <section className='extra-content-videos wood'>
      <div>
        <div className='extra-content-videos-header'>
          <div>
            <h2>{data.title ? data.title : 'Videos'}</h2>
            {data.description && (
              <p>{data.description}</p>
            )}
          </div>
          <Link to={formatLink(videosPage)}>
            <span>{data.cta ? data.cta : 'Discover more videos'}</span>
            <InternalLinkIcon />
          </Link>
        </div>

        <div className='extra-content-videos-container'>
          {data.videos.map(video => (
            <Link
              key={video._id}
              to={formatLink(video)}
              className='extra-content-videos-card'>
              <img
                src={urlFor(video.teaser?.image?.asset ? video.teaser.image.asset : video.image).width(260).quality(90).url()}
              />
              <p>{video.title}</p>
              <InternalLinkIcon />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ExtraContentVideos;
